import type { PublicAgent } from '@magic/schemas/agents';
import styled from 'styled-components';

import { Messages } from './components/messages';
import { Prompt } from './components/prompt';
import { useChat } from './hooks/use-chat';

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export interface ChatProps {
  preview?: boolean;
  agent: PublicAgent;
}

export const Chat = ({ agent, preview }: ChatProps) => {
  const { messages, input, handleInputChange, handleSubmit, isLoading } =
    useChat({
      api: `${import.meta.env.VITE_CHAT_API_URL}widget/${agent.workspaceId}/${
        agent.id
      }`,
      preview,
    });

  return (
    <Container>
      <Messages agent={agent} messages={messages} isLoading={isLoading} />
      <Prompt
        value={input}
        isLoading={isLoading}
        onChange={handleInputChange}
        onSubmit={handleSubmit}
      />
    </Container>
  );
};
